import { observable } from "@legendapp/state";

export const $currentAttendanceId = observable<string>('');
export const $selectedSituation = observable<string>('');
